<template>
  <div class="container">
    <div class="box">
      <div class="columns is-multiline" v-if="gallery">
        <div class="column is-12">
          <div class="field">
            <label class="label">Gallery's title</label>
            <div class="control">
              <input type="text" class="input" placeholder="Title" v-model="gallery.title">
            </div>
          </div>
        </div>
        <div class="column is-12">
          <quill-editor v-model="gallery.description" :options="editorOptions">
          </quill-editor>
          <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>
        <div class="column is-12">
          <div class="field">
            <div class="control">
              <div class="file">
                <label class="file-label">
                  <input @change="uploadImages" class="file-input" type="file" name="resume" multiple accept=".jpg, .jpeg, .png" :disabled="uploading"/>
                  <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="uploading">
          <progress class="progress is-primary" :value="progress" max="100"></progress>
        </div>
        <div class="column is-12">
          <div class="gallery">
            <div class="columns is-multiline" v-if="!media.hasOwnProperty('.value')">
              <template v-for="(img, key) in galleryMedia" v-if="img.src && img.path">
                <div class="column is-narrow" @click="showImage(img['.key'])" :key="key">
                  <GalleryImage :image-path="img.path" :thumb-size="480"></GalleryImage>
                  <a class="gallery-image-delete button is-small is-danger is-rounded" @click="deleteImage(img['.key'])">
                      <span class="icon is-small">
                        <i class="fas fa-trash"></i>
                      </span>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- the form buttons -->
      <button type="submit" class="button is-success" @click="addGallery('published')">Publish</button>
      <button type="submit" class="button is-info" @click="addGallery('saved')">Save Draft</button>
      <router-link to="/admin/galleries" class="button is-danger">Cancel</router-link>

      <!-- notification -->
      <transition mode="out-in" name="fade">
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>{{notification.message}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mediaRef, galleriesRef } from '@/firebase_config'
import notifier from '@/mixins/notifier'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'

import GalleryImage from './GalleryImage'
import ImageModal from '../../shared/ImageModal'

export default {
  name: 'user-gallery',
  data () {
    return {
      showModal: false,
      currentUser: firebase.auth().currentUser,
      uploading: false,
      uploadingFilesCount: 0,
      uploadedFilesCount: 0,
      fileCount: 0,
      gallery: {
        title: '',
        description: '',
        state: null,
        images: []
      },
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  mixins: [imageLoader, notifier],
  methods: {
    deleteImage (key) {
      let i = this.gallery.images.indexOf(key)
      if (i > -1) {
        this.gallery.images.splice(i, 1)
      }
    },
    showImage (key) {
      this.currentMediaId = key
      this.showModal = true
    },
    addGallery (state) {
      this.gallery.state = state
      galleriesRef.push({
        ...this.gallery,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }).then(() => {
        this.showNotification('success', 'Gallery added successfully')
      })
    },
    uploadImages (e) {
      let files = e.target.files

      this.uploading = true
      this.uploadedFilesCount = 0
      this.uploadingFilesCount = files.length

      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)// .then(this.addImageToMedia)
    },
    handleUploadProgress (snapshot) {
      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    },
    handleUploadError (error) {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          // User doesn't have permission to access the object
          break
        case 'storage/canceled':
          console.log('storage/canceled')
          // User canceled the upload
          break
        case 'storage/unknown':
          console.log('storage/unknown')
          // Unknown error occurred, inspect error.serverResponse
          break
        default:
          console.log(error)
      }
    },
    handleUploadComplete () {
      this.uploadedFilesCount++
    },
    addImageToMedia (snapshot) {
      this.showNotification('success', snapshot.metadata.name + ' uploaded. ' + this.fileCount + ' images remaining')

      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }
      mediaRef.push(mediaObj).then(
        media => {
          this.placeImageInGallery(media.key)
        }
      )
    },
    placeImageInGallery (key) {
      this.gallery.images.push(key)
    }
  },
  watch: {
    progress (val) {
      if (val === 100) {
        this.uploading = false
        this.uploadingFilesCount = 0
        this.uploadedFilesCount = 0
      }
    }
  },
  computed: {
    galleryMedia () {
      return this.media
        .filter(media => {
          let mediaKey = media['.key']
          return (this.gallery.images && this.gallery.images.length && this.gallery.images.indexOf(mediaKey) > -1)
        })
    },
    progress () {
      return (this.uploadedFilesCount / this.uploadingFilesCount) * 100
    }

  },
  components: {
    GalleryImage,
    ImageModal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery {
    margin: 16px;
  }
  .gallery-image-container {
    position: relative;
    .gallery-image-delete {
      position: absolute;
      top: 10%;
      right: 10%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/GalleriesNew.vue